import React, { FC } from "react";

interface Props {
  core: string;
  purpose: string;
}

const DocumentTitleSettings: FC<Props> = ({ core, purpose }) => {
  return (
    <>
      <div className="dreamhome-main-title base-color">{core}</div>
      <div></div>
      <div className="active-create-container">
        <div>{purpose}</div>
      </div>
    </>
  );
};

export default DocumentTitleSettings;
